import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { ActionsModal } from 'src/app/core/modal/actions/actions-modal';
import { ConfigService } from 'src/app/core/service/config.service';
import { ApiAuctionsService } from 'src/app/features/bidders/core/service/api-auctions.service';
import { ConfirmComponent } from 'src/app/shared/actions/delete/confirm.component';

@Component({
  selector: 'app-list-bidders',
  templateUrl: './list-bidders.component.html',
  styleUrls: ['./list-bidders.component.css']
})
export class ListBiddersComponent implements OnInit {
  listOfItems: any;
  auctionId: any | undefined;
  loading = true;
  // data confirm action (delete or change status )
  dataConfirmActions: ActionsModal | undefined;

  @Input() ReloadList: number = 0;
  constructor(
    private _activatedRouter: ActivatedRoute,
    public _auctionApi: ApiAuctionsService,
    public _config: ConfigService,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.auctionId = this._activatedRouter.snapshot.params["id"];
    this.onGetAuctionBidders();
  }
  ngOnChanges(changes: any): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if ('ReloadList' in changes) {
      console.log("reloadList Changes", changes.ReloadList);
      if (changes.ReloadList.currentValue) {
        this.onGetAuctionBidders();
      }
    }
  }
  onDelete(user: any) {
    this.dataConfirmActions = {
      title: this._config.translate.instant("actions.delete"),
      icon: 'warning',
      text: this._config.translate.instant("actions.deleteTxt"),
      confirm: this._config.translate.instant("actions.confirm"),
      cancel: this._config.translate.instant("actions.cancel"),
      data: user
    };

    const dialogRef = this.dialog.open(ConfirmComponent, {
      data: this.dataConfirmActions,
      panelClass: 'customDialogStyle'
    });

    dialogRef.afterClosed().subscribe((res) => {

      if (res == 'success') {
        this.loading = true;
        this._auctionApi.removeBidders(this.auctionId, { user_id: user.id }).subscribe({
          next: (data) => {
            this._config.toastrService.success(this._config.translate.instant('users.deleteSuccessfully'));
            this.onGetAuctionBidders();
          }, error: (error) => {
            // error.errors.forEach((err: any) => {
            //   this._config.toastrService.error(err.massage);
            // });
            this._config.showErrors(error);

          }
        });

      }


    });
  }

  onGetAuctionBidders() {
    if (this._config._router.url.includes("rooms/Multi/detailes")) {
      this._auctionApi.getRoomBidders(this.auctionId).subscribe({
        next: (data) => {
          this.listOfItems = data.data.list
        }, error: (err) => {
          // if (err.errors[0].field == "itemNotFound") {
          //   this._config._router.navigate(["/no-permission"])
          // }
          this._config.showErrors(err)
          this.loading = false;
        }
      });
    } else {
      this._auctionApi.getAuctionBidders(this.auctionId).subscribe({
        next: (data) => {
          this.listOfItems = data.data.list
        }, error: (err) => {
          // if (err.errors[0].field == "itemNotFound") {
          //   this._config._router.navigate(["/no-permission"])
          // }
          this._config.showErrors(err)
          this.loading = false;
        }
      });
    }

  }
}
